var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.documentReady)?_c('iframe',{staticClass:"treatment-viewer",attrs:{"src":_vm.viewerUrl,"allow":"fullscreen","referer":"no-referer"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }